export default __webpack_public_path__ + "static/media/kangaroo.24ac3d14.png";